import {
	faChevronLeft,
	faEdit,
	faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { useState } from "react";
import { store } from "react-notifications-component";
import ReactPaginate from "react-paginate";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
	Button,
	CardLink,
	Col,
	FormGroup,
	Input,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Row,
	Spinner,
} from "reactstrap";
import { Dispatch } from "redux";
import { ManageCategoryAction } from "../../actions/manageCategoryAction";
import { showAlert } from "../common/functions";
import ManageCategoryModal from "./manageCategoryDetail";
import Select from "react-select";

interface MusicPlatformProps {
	dispatch: Dispatch<any>;
	manageCategoryData: any;
}

const ManageCategoryList: React.SFC<MusicPlatformProps> = ({
	dispatch,
	manageCategoryData,
}) => {
	const history = useHistory();
	const [currentPage, setCurrentPage] = useState<number>(1);
	const [selectedId, setSelectedId] = useState(-1);
	const [editedId, setEditedId] = useState(0);
	const [showModal, setShowModal] = useState(false);
	const [openDetailModal, setOpenDetailModal] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [searchText, setSearch] = useState<string>("");
	const [debouncedSearch, setDebouncedSearch] = useState<string>("");
	const [selectedStatus, setSelectedStatus] = useState<any>(null);
	const [detailLoading, isUpdateDetailLoading] = useState<boolean>(false);

	React.useEffect(() => {
		const handler = setTimeout(() => {
			setCurrentPage(1);
			setDebouncedSearch(searchText);
		}, 400);
		return () => {
			clearTimeout(handler);
		};
	}, [searchText]);

	React.useEffect(() => {
		const body = {
			pageNumber: currentPage,
			pageSize: 25,
			searchText: debouncedSearch.trim().length ? debouncedSearch : null,
			isActive: selectedStatus,
		};
		setShowModal(true);
		dispatch(ManageCategoryAction.manageCategoryGetByFilter(body));
	}, [debouncedSearch]);

	React.useEffect(() => {
		const body = {
			pageNumber: 1,
			pageSize: 25,
			searchText: debouncedSearch.trim().length ? debouncedSearch : null,
			isActive: null,
		};
		setShowModal(true);
		dispatch(ManageCategoryAction.manageCategoryGetByFilter(body));
	}, []);

	React.useEffect(() => {
		if (manageCategoryData?.isUpdateStatus && manageCategoryData?.isSuccess) {
			const body = {
				pageNumber: currentPage,
				pageSize: 25,
				searchText: debouncedSearch.trim().length ? debouncedSearch : null,
				isActive: selectedStatus,
			};
			setShowModal(true);
			dispatch(ManageCategoryAction.manageCategoryGetByFilter(body));
			const alertMessage = manageCategoryData?.status;
			if (alertMessage && alertMessage != "") {
				store.addNotification({
					title: "Success!",
					message: alertMessage,
					type: "success",
					insert: "top",
					container: "top-right",
					animationIn: ["animate__animated", "animate__fadeIn"],
					animationOut: ["animate__animated", "animate__fadeOut"],
					dismiss: {
						duration: 5000,
						onScreen: true,
					},
				});
				manageCategoryData.isUpdateStatus = false;
				toggleDetailModal();
				window.localStorage.setItem("alertMessage", "");
			}
		}
	}, [manageCategoryData?.isUpdateStatus]);

	const handleCloseClick = () => {
		setShowDeleteModal(false);
	};

	const handleLoadDeleteModal = () => {
		dispatch(ManageCategoryAction.manageCategoryDelete(selectedId));
		setShowModal(true);
		setShowDeleteModal(false);
	};

	const toggleDetailModal = () => {
		setOpenDetailModal(false);
		setEditedId(0);
	};

	if (
		manageCategoryData &&
		!manageCategoryData.isLoading &&
		manageCategoryData.isListSuccess
	) {
		manageCategoryData.isListSuccess = false;
		if (showModal) {
			setShowModal(false);
		}
	}
	if (
		selectedId >= 0 &&
		manageCategoryData.isSuccess &&
		(manageCategoryData.isDeleteCompleted ||
			manageCategoryData.isSuccessSave) &&
		!manageCategoryData.isError
	) {
		showAlert(manageCategoryData.status, false);
		manageCategoryData.isSuccess = false;
		manageCategoryData.isDeleteCompleted = false;
		const body = {
			pageNumber:
				manageCategoryData?.items?.categories?.length === 1
					? currentPage - 1
					: currentPage,
			pageSize: 25,
			searchText: debouncedSearch.trim().length ? debouncedSearch : null,
			isActive: selectedStatus,
		};
		setShowModal(true);
		dispatch(ManageCategoryAction.manageCategoryGetByFilter(body));
		setCurrentPage(
			manageCategoryData?.items?.categories?.length === 1
				? currentPage - 1
				: currentPage
		);
		setSelectedId(-1);
	}
	if (!manageCategoryData.isSuccess && manageCategoryData.isError) {
		if (manageCategoryData.status === "Unauthorized") {
			history.push("/401");
		} else {
			showAlert(manageCategoryData.status, true);
		}
		manageCategoryData.isError = false;
		isUpdateDetailLoading(!detailLoading);
		setSelectedId(-1);
		if (showModal) {
			setShowModal(false);
		}
	}

	const handleSelectForDelete = (id: any) => {
		setSelectedId(id);
		setShowDeleteModal(true);
	};

	const handleActiveCategory = async (id: any, status: any) => {
		const data = {
			categoryId: id,
			isActive: !status,
		};
		setShowModal(true);
		await dispatch(ManageCategoryAction.manageCategoryUpdateStatus(data));
	};

	const handleStatusDropdown = async (value: string) => {
		setCurrentPage(1);
		setShowModal(true);
		let isActive: boolean | null;
		if (value === "active") {
			setSelectedStatus(true);
			isActive = true;
		} else if (value === "inactive") {
			setSelectedStatus(false);
			isActive = false;
		} else {
			setSelectedStatus(null);
			isActive = null;
		}
		const body = {
			pageNumber: 1,
			pageSize: 25,
			searchText: debouncedSearch.trim().length ? debouncedSearch : null,
			isActive,
		};
		dispatch(ManageCategoryAction.manageCategoryGetByFilter(body));
	};
	
	return (
		<div data-testid="manageCategoryPage" className="manageCategory-list">
			<div className="card-box">
				<div className="card-box-link-back-div">
					<FontAwesomeIcon icon={faChevronLeft} />
					<CardLink
						onClick={() => history.push("/contextualmedia")}
						className="card-box-link-back"
						data-testid="bible-backtolist"
					>
						Back to List
					</CardLink>
				</div>
			</div>
			<div className="card-box">
				<Row className="filter-link-container justify-content-between">
					<Col lg="3">
						<Input
							type="search"
							onChange={(event) => setSearch(event.target.value)}
							className="form-control"
							id="search-filter"
							placeholder="Search here..."
							value={searchText}
						/>
					</Col>
					<Col
						lg={9}
						className="d-flex justify-content-end align-items-center gap-2"
					>
						<Col lg={3}>
							<Select
								id="statusSelect"
								className="status-select"
								placeholder="Select Status"
								isClearable
								options={[
									{ value: "active", label: "Active" },
									{ value: "inactive", label: "Inactive" },
								]}
								onChange={(selected) => {
									if (selected) {
										handleStatusDropdown(selected.value);
									} else {
										handleStatusDropdown("");
									}
								}}
								styles={{
									clearIndicator: (base) => ({
										...base,
										cursor: "pointer",
									}),
								}}
							/>
						</Col>
						<Button
							id="submit"
							data-testid="createNewCategory"
							className="btn-gray"
							onClick={() => {
								setOpenDetailModal(true);
							}}
						>
							Add New Category
						</Button>
					</Col>
				</Row>
			</div>

			<div className="manageCategory-table">
				<table className="table table-hover" data-testid="manageCategoryTable">
					<thead data-testid="manageCategoryTableHead">
						<tr>
							<th scope="col" data-testid="detail-th">
								Details
							</th>
							<th scope="col" data-testid="categoryname-th">
								Category Name
							</th>
							<th scope="col" data-testid="mediatype-th">
								Media Type
							</th>
							<th scope="col" data-testid="description-th">
								Description
							</th>
							<th scope="col" data-testid="categorystatus-th">
								Categories Status
							</th>
							<th scope="col" data-testid="delete-th">
								Delete
							</th>
						</tr>
					</thead>
					<tbody data-testid="manageCategoryTableBody">
						{showModal ? (
							<tr>
								<td colSpan={6} className="text-center">
									<Spinner />
								</td>
							</tr>
						) : (
							<>
								{manageCategoryData &&
								manageCategoryData?.items?.categories?.length > 0 ? (
									manageCategoryData?.items?.categories?.map((data: any, i: number) => (
										<>
											<tr key={data.categoryId}>
												<th scope="row" className="icon-column" data-testid={`manageCategoryDetailButton${i+1}`}>
													<FontAwesomeIcon
														size="2x"
														icon={faEdit}
														title="Details"
														cursor="pointer"
														className="detailButton"
														onClick={() => {
															setOpenDetailModal(true);
															setEditedId(data?.categoryId);
														}}
													/>
												</th>
												<td id="platformName">{data?.categoryName} </td>
												<td id="mediaType">{data?.mediaTypeCode} </td>
												<td id="description">
													{data?.description.length === 0
														? "-"
														: data?.description}{" "}
												</td>
												<td id="actionswitch" className="text-center">
													<FormGroup switch>
														<Input
															type="switch"
															className="active-switch"
															data-testid="musicUpdateStatus"
															id="activeInactiveSwitch"
															checked={data?.isActive}
															onChange={() =>
																handleActiveCategory(
																	data?.categoryId,
																	data?.isActive
																)
															}
														/>
													</FormGroup>
												</td>

												<td className="icon-column">
													<FontAwesomeIcon
														size="2x"
														icon={faTrashAlt}
														data-testid="manageCategoryDeleteButton"
														data-bs-toggle="tooltip"
														cursor="pointer"
														data-bs-placement="bottom"
														title="Delete"
														onClick={() =>
															handleSelectForDelete(data?.categoryId)
														}
													/>
												</td>
											</tr>
										</>
									))
								) : (
									<tr>
										<td colSpan={6} className="text-center h6">
											No Data found.
										</td>
									</tr>
								)}
							</>
						)}
					</tbody>
				</table>
			</div>
			<div className="pagination">
				<ReactPaginate
					previousLabel={"<<"}
					nextLabel={">>"}
					breakLabel={"..."}
					pageCount={Math.ceil(+manageCategoryData?.items?.totalCount / 25)}
					marginPagesDisplayed={2}
					pageRangeDisplayed={3}
					onPageChange={(data) => {
						setCurrentPage(data.selected + 1);
						const body = {
							pageNumber: data.selected + 1,
							pageSize: 25,
							searchText: debouncedSearch.trim().length
								? debouncedSearch
								: null,
							isActive: selectedStatus,
						};
						setShowModal(true);
						dispatch(ManageCategoryAction.manageCategoryGetByFilter(body));
					}}
					containerClassName={"pagination"}
					pageClassName={"page-item"}
					previousClassName={"page-item"}
					breakClassName={"page-item"}
					breakLinkClassName={"page-link"}
					nextClassName={"page-item"}
					pageLinkClassName={"page-link"}
					previousLinkClassName={"page-link"}
					nextLinkClassName={"page-link"}
					activeClassName={"active"}
					forcePage={currentPage - 1}
				/>
			</div>
			<Modal
				isOpen={showDeleteModal}
				backdrop="static"
				centered
				data-testid="deleteModal"
			>
				<ModalHeader>Delete Category</ModalHeader>
				<ModalBody className="modal-body">
					<form name="deleteCategoryForm">
						<div
							className="col-form-label"
							data-testid="manageCategoryDeleteMessage"
						>
							Deleting this category will permanently remove. To confirm, please
							click Confirm Delete.
						</div>
					</form>
				</ModalBody>
				<ModalFooter>
					<Button
						type="button"
						color="secondary"
						data-bs-dismiss="modal"
						onClick={handleCloseClick}
						data-testid="cancelDeleteButton"
					>
						Cancel
					</Button>
					<Button
						type="button"
						color="primary"
						onClick={handleLoadDeleteModal}
						data-testid="confirmDeleteButton"
					>
						Confirm Delete
					</Button>
				</ModalFooter>
			</Modal>
			<ManageCategoryModal
				isOpen={openDetailModal}
				toggleDetailModal={toggleDetailModal}
				id={editedId}
				dispatch={dispatch}
				manageCategoryData={manageCategoryData}
				detailLoading={detailLoading}
			/>
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { manageCategoryData, languageData } = state;
	return {
		manageCategoryData,
		languageData,
	};
};

export default connect(mapStateToProps)(ManageCategoryList);
